export enum GiftCodeStatus {
  UNPROVIDED = 'Unprovided',
  PROVISION = 'Provision',
  USED = 'Used'
}
